import { type ComponentProps, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

type PersonSelectDropdownProps = ComponentProps<'ul'>;

const _PersonSelectSuggestionsContainer = forwardRef<HTMLUListElement, PersonSelectDropdownProps>(
  ({ className, ...props }: PersonSelectDropdownProps, forwardedRef) => {
    return (
      <ul
        ref={forwardedRef}
        className={cn(
          'scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar scrollbar-track-transparent scrollbar-thumb-grey-7 hover:scrollbar-track-grey-4 absolute z-10 flex flex-col gap-1 overflow-y-auto rounded-4 border-none bg-grey-1 px-1.5 py-2 shadow-popover',
          className,
        )}
        data-select-person-options={true}
        {...props}
      />
    );
  },
);

_PersonSelectSuggestionsContainer.displayName = '_PersonSelectSuggestionsContainer';

export const PersonSelectSuggestionsContainer = memo(_PersonSelectSuggestionsContainer);
PersonSelectSuggestionsContainer.displayName = 'PersonSelectSuggestionsContainer';
